import { Currency } from "@/gql/graphql";
import { formatCurrency } from "@/lib/Formatters/formatCurrency";

/**
 * A unit price of zero means the supplier offers the extra free of charge,
 * which formatCurrency would otherwise render as an empty value.
 */
export function formatPurchasableExtraPrice(
  unitPrice: number,
  currency: Currency,
) {
  if (unitPrice === 0) {
    return "Free of charge";
  }

  return formatCurrency(unitPrice, currency);
}
